/* DUO builder: pick the key, add Plus Ones, name it, then add to cart or, while
   ordering is closed, save the drink with an email. Shared by the product page
   and the homepage flavour switcher.

   Markup contract, inside an element carrying [data-duo-build]:
     [data-duo-version]  buttons, each with data-version="low|high",
                         data-variant="<id>", data-price="<cents>", data-mg="<caffeine>"
     [data-duo-chips]    container the Plus Ones are written into. With
                         data-inline: the favourites (data-top) as photo pills,
                         then "+ N more" that opens the rest in place, then one
                         fact line per Plus One she has added
     [data-duo-recipe]   the live recipe line ("Double Take · High Key + Collagen")
     [data-duo-price]    the live total
     [data-duo-mg]       optional live caffeine line
     [data-duo-meter]    optional caffeine meter (its first child is the fill)
     [data-duo-mgof]     optional "~50 of 180 mg" beside the meter (v3)
     [data-duo-dname]    optional "name your drink" input
     [data-duo-kname]    optional kid's first name, for their stickers only (goes on the Little line)
     [data-duo-add]      the main button
     [data-duo-note]     optional line under the button
     [data-duo-btnprice] optional total inside the main button (open state only)
     [data-duo-little]   optional "One for them?" buttons, each with data-little
                         (handle), data-variant and data-price; "" means no thanks
     [data-duo-save-panel] optional "Save my drink" panel holding a customer form
   The root carries data-name, data-handle, data-version and data-cap.
   Anything with [data-duo-sticky] on the page mirrors the recipe, price and
   button of the first builder.

   Caffeine free (Kellie, 2026-09-23) is a free Plus One, not a build: it takes
   the tea and the kick out, so it goes on Low Key only, and nothing
   caffeinated can be added on top of it.

   Caffeine rule: Health Canada caps a serving at 180 mg. The builder totals the
   build plus every caffeinated Plus One and refuses any chip that would cross
   the cap, the same way it totals the price.

   A Plus One on us (Paul, 2026-09-30: "if you get two Plus Ones the third one's on
   us"): Shopify's automatic discount "Add 3 Plus Ones: one is on us" takes the
   lowest-priced Plus One off any order that has three or more, once per order. The
   builder works out what this add changes (it reads the Plus Ones already in the
   cart), so its total is what the cart will charge. Root attribute data-p1-offer
   (Theme settings > DUO > Cart); never for a visitor who is not signed in.

   Changing a drink from the cart (?edit=<its _build id>, snippets/duo-cart-edit.liquid):
   the button reads "Update my drink" and the drink and its Plus Ones are replaced,
   not added again. Its Little DUO, if any, stays as it is.

   A visitor who is not signed in (prices are for members): the button reads "See
   your price". One tap puts her drink in the cart, sends her to Shopify's sign-in
   and brings her back to the cart with her drink and her total (Paul, 2026-10-01:
   "I want what they build to go into the cart", after the sign-in had dropped her
   at the top of the drink page). The lines are also kept on this device
   (duo:pending) so assets/duo.js can put them back if the cart came back empty.

   Changing flavour happens in place (2026-10-01): the other drinks' sections are
   fetched once the page is quiet and swapped in on the tap, her build kept, so a
   flavour dot no longer loads a page. See "Changing flavour in place" below.

   Closed state (theme setting "Ordering open" off): the main button reads
   "Save my drink" and opens an email field instead of adding to the cart. The
   build rides along as customer tags (saved-<flavour>, key-<build>, p1-<plus
   one>) so the email when ordering opens can go to each flavour's list, and it is kept
   in this browser so the page shows her drink again when she comes back.
*/
(function () {
  if (window.__duoBuilder) return;
  window.__duoBuilder = true;

  var NAME = { low: 'Low Key', high: 'High Key' };
  var GROUPS = [
    { key: 'down', label: 'Take it down' },
    { key: 'add', label: 'Add to it' },
    { key: 'up', label: 'Turn it up' },
    { key: 'yours', label: 'Finish it' }
  ];
  var STORE = 'duo:saved';
  /* Prices are for members (upline, 2026-09-29). Not signed in: snippets/duo-head.liquid
     puts data-duo-guest on <html>, the page carries no prices, money() prints nothing,
     and the button reads "See your price": her drink goes into the cart and she
     signs in on the way to it. */
  var GUEST = document.documentElement.hasAttribute('data-duo-guest');

  /* Read when the first builder starts, not when this file runs: the file loads
     async (2026-10-01) and may run before the page has reached the list. */
  var PLUS_ONES = [];
  function loadP1() {
    if (PLUS_ONES.length) return;
    try {
      var el = document.getElementById('duo-plusones');
      if (el) PLUS_ONES = JSON.parse(el.textContent);
    } catch (e) { PLUS_ONES = []; }
  }

  function money(cents) {
    if (GUEST) return '';
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function buildId() {
    return 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE) || 'null'); } catch (e) { return null; }
  }
  function writeStore(v) {
    try { localStorage.setItem(STORE, JSON.stringify(v)); } catch (e) { /* private mode: fine */ }
  }
  /* Mix and match (Paul, 2026-09-27): her 3 or 6 cans, built one by one across the
     drink pages. Lives for this tab only: { n, cans: [{ name, c }] }. */
  var MIX = 'duo:mix';
  function readMix() {
    try {
      var m = JSON.parse(sessionStorage.getItem(MIX) || 'null');
      return m && (m.n === 3 || m.n === 6) && Array.isArray(m.cans) && m.cans.length < m.n ? m : null;
    } catch (e) { return null; }
  }
  function writeMix(m) {
    try { if (m) sessionStorage.setItem(MIX, JSON.stringify(m)); else sessionStorage.removeItem(MIX); } catch (e) { /* fine */ }
  }
  /* The drink a visitor put in her cart on the way to the sign-in: { ids: [_build],
     items: [the lines as posted], at }. A second tap before she signs in replaces
     those lines; assets/duo.js puts them back if she returns to an empty cart. */
  var PEND = 'duo:pending';
  function readPending() {
    try {
      var p = JSON.parse(localStorage.getItem(PEND) || 'null');
      return p && Array.isArray(p.ids) && Array.isArray(p.items) && Date.now() - p.at < 72e5 ? p : null;
    } catch (e) { return null; }
  }
  function writePending(v) {
    try { localStorage.setItem(PEND, JSON.stringify(v)); } catch (e) { /* private mode: the cart still has it */ }
  }
  function signIn(ret) {
    window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(ret && ret.charAt(0) === '/' ? ret : '/cart');
  }
  /* Open the connections the sign-in needs while her drink is being saved. */
  var warmed = false;
  function warmSignIn() {
    if (warmed) return;
    warmed = true;
    ['https://shopify.com', 'https://shop.app'].forEach(function (h) {
      var l = document.createElement('link');
      l.rel = 'preconnect'; l.href = h;
      document.head.appendChild(l);
    });
  }

  function Builder(root) {
    this.root = root;
    this.picked = new Set();
    this.version = root.dataset.version || 'high';
    this.defaultVersion = this.version;
    this.cap = parseInt(root.dataset.cap || '180', 10);
    this.handle = root.dataset.handle || '';
    // The drink's menu decides its Plus Ones (snippets/duo-menu-data.liquid, Paul, Oct 27): at most
    // four, in that order, no "+ more". A menu drink also names its build after the menu ("Collagen").
    this.allow = (root.dataset.p1Allow || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    this.buildName = root.dataset.buildName || '';
    this.chipsBox = root.querySelector('[data-duo-chips]');
    this.recipeEl = root.querySelector('[data-duo-recipe]');
    this.priceEl = root.querySelector('[data-duo-price]');
    this.mgEl = root.querySelector('[data-duo-mg]');
    this.meterEl = root.querySelector('[data-duo-meter]');
    this.mgOfEl = root.querySelector('[data-duo-mgof]');
    this.dnameEl = root.querySelector('[data-duo-dname]');
    this.addBtn = root.querySelector('[data-duo-add]');
    this.noteEl = root.querySelector('[data-duo-note]');
    this.qtyEl = root.querySelector('[data-duo-qty] input');
    this.btnPriceEl = root.querySelector('[data-duo-btnprice]');
    this.saveForm = root.querySelector('[data-duo-save-panel] form');
    this.littleBtns = Array.prototype.slice.call(root.querySelectorAll('[data-duo-little] button[data-little]'));
    this.littleSel = root.querySelector('[data-duo-little-select]');
    this.pairBtn = root.querySelector('[data-duo-pair]');
    this.littleRow = root.querySelector('[data-duo-little-row]');
    this.nameToggle = root.querySelector('[data-duo-name-toggle]');
    this.addonsLabel = root.querySelector('[data-duo-addons-label]');
    this.p1SumEl = root.querySelector('[data-duo-p1sum]');
    this.mgShortEl = root.querySelector('[data-duo-mgshort]');
    this.soloPriceEl = root.querySelector('[data-duo-solo-price]');
    this.pairPriceEl = root.querySelector('[data-duo-pair-price]');
    this.zeroBtn = root.querySelector('[data-duo-version] [data-zero]');
    // How many: 1 can, 3 cans or a 6-pack; one price per can since 2026-10-01 (packOff is 0 unless a pack discount is set again)
    this.packBtns = Array.prototype.slice.call(root.querySelectorAll('[data-duo-packs] [data-pack]'));
    this.pack = 1;
    this.packOff = { 1: 0, 3: parseInt(root.dataset.pack3Off || '0', 10), 6: parseInt(root.dataset.pack6Off || '0', 10) };
    this.perkEl = root.querySelector('[data-duo-pack-perk]');
    // the three steps (Paul, 2026-09-27): a summary line each, and a tick once she has made the step her own
    this.steps = Array.prototype.slice.call(root.querySelectorAll('[data-duo-step]'));
    this.sum1 = root.querySelector('[data-duo-sum1]');
    this.sum2 = root.querySelector('[data-duo-sum2]');
    this.sum3 = root.querySelector('[data-duo-sum3]');
    this.touchedSteps = {};
    // 3 + 3: three of this build + three caffeine free (0 mg), 6-pack only (was AM + PM, renamed Sept 30)
    this.setBox = root.querySelector('[data-duo-set]');
    this.setOn = false;
    this.pmBtns = Array.prototype.slice.call(root.querySelectorAll('[data-duo-set] [data-pm]'));
    this.pm = '';
    this.pmPicked = new Set();
    if (this.setBox) {
      var sa = this.setBox.querySelector('[data-duo-set-adds]');
      (sa && sa.dataset.default || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean).forEach(function (h) { this.pmPicked.add(h); }, this);
      var soft = this.pmBtns.filter(function (x) { return x.dataset.pm === 'soft-launch'; })[0];
      this.pm = (soft || this.pmBtns[0] || { dataset: {} }).dataset.pm || '';
    }
    // each caffeine free can can be its own flavour (Paul, 2026-09-28); 0 = a flavour tap sets all three
    this.pmDays = [this.pm, this.pm, this.pm];
    this.pmDay = 0;
    // mix and match: 'pick' (build each can) or 'surprise' (our pick, all different)
    this.mixHow = 'pick';
    // "Mix it up?" (Paul, Oct 29: "too much to look at"): 3 + 3, Surprise me and Pick each stay out of sight until she opens it
    this.mixToggle = root.querySelector('[data-duo-mixit]');
    this.mixPanel = root.querySelector('[data-duo-mixpanel]');
    this.mixOpen = false;
    this.drinks = [];
    try { var dj = root.querySelector('[data-duo-drinks]') || document.querySelector('[data-duo-drinks]'); if (dj) this.drinks = JSON.parse(dj.textContent) || []; } catch (e) { this.drinks = []; }
    this.little = '';
    // the flavour swirl's second flavour
    this.swirlBox = root.querySelector('[data-duo-swirl]');
    this.swirlBtns = Array.prototype.slice.call(root.querySelectorAll('[data-duo-swirl] [data-swirl]'));
    this.swirlNameEl = root.querySelector('[data-duo-swirl-name]');
    var sd = root.dataset.swirlDefault || '';
    var sdb = this.swirlBtns.filter(function (x) { return x.dataset.swirlKey === sd; })[0] || this.swirlBtns[0];
    this.swirl = sdb ? sdb.dataset.swirl : '';
    // how she wants them: 'same', 'set' (3 + 3) or 'mix' (build each can)
    this.mode = 'same';
    this.mixBox = root.querySelector('[data-duo-mix]');
    this.packFs = root.querySelector('[data-duo-packs]');
    this.littleBox = root.querySelector('[data-duo-little]');
    this.mixing = this.packBtns.length ? readMix() : null;
    if (this.mixing) { this.mode = 'mix'; this.pack = this.mixing.n; }
    this.closed = root.hasAttribute('data-closed');
    this.guest = GUEST;
    this.versionBtns = Array.prototype.slice.call(root.querySelectorAll('[data-duo-version] [data-version]'));
    this.sticky = null;
    // a Plus One on us, and changing a drink that is already in the cart
    this.offer = root.hasAttribute('data-p1-offer') && !GUEST && !this.closed;
    this.cartP1 = { n: 0, m: 0 };
    this.editId = '';
    try { this.editId = new URLSearchParams(window.location.search).get('edit') || ''; } catch (e) { this.editId = ''; }
    // changing a saved drink from the cart replaces it while ordering is closed too (Nov 2)
    if (GUEST || !this.packBtns.length || this.mixing) this.editId = '';
    this.drawChips();
    this.drawSet();
    this.restore();
    this.bind();
    this.render();
    this.readCart();
    // arrived from a menu card, the menu sheet or the cart while ordering is closed: the email box is already open
    // arrived from a menu card: the panel opens, but nothing saves until she taps (she may change the build first)
    if (this.closed && /[?&]save=1/.test(location.search)) this.openSave(true);
    // Pictures that only show after a tap (the pills behind "+ more", the swirl row,
    // the evening panel, the Little DUO row) load once the page is quiet, so they are
    // there on the first frame she opens them (2026-09-28: 4 to 9 painted empty for a frame).
    var card = root;
    var ready = function () { Array.prototype.forEach.call(card.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; }); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(ready, { timeout: 3000 });
    else window.setTimeout(ready, 1200);
  }

  /* Plus Ones, laid out short (Paul, 2026-09-26: "too much to scroll", then
     "make those pills intuitive"):
     - Caffeine free sits with the key choice ([data-duo-cfslot] or the
       [data-zero] button), since it is a caffeine decision, not an add-in.
     - Each pill is the ingredient's photo, its plain name and the price.
     - data-inline (product page): the favourites (data-top) show, "+ N more"
       opens the rest in the same grid, and each Plus One she adds gets one
       fact line underneath, with any allergen in bold.
     - Otherwise (homepage switcher): favourites, then a closed "More Plus
       Ones" row holding the rest in groups. */
  Builder.prototype.drawChips = function () {
    if (!this.chipsBox || this.chipsBox.dataset.drawn) return;
    var self = this;
    var cfSlot = this.root.querySelector('[data-duo-cfslot]');
    // desktop shows six (three across), the phone four (two across)
    var wide = this.chipsBox.dataset.topWide && window.matchMedia && window.matchMedia('(min-width: 900px)').matches;
    var topList = ((wide ? this.chipsBox.dataset.topWide : this.chipsBox.dataset.top) || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (this.allow.length) topList = this.allow;

    function tile(a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'duo-chip duo-tile' + (a.cf ? ' duo-tile--cf' : '') + (a.img ? ' duo-tile--img' : '');
      b.dataset.p1 = a.handle;
      b.setAttribute('aria-pressed', 'false');
      var price = GUEST ? '' : a.price ? '+' + money(a.price) : 'Free';
      var img = a.img;
      if (img) {
        b.innerHTML = '<span class="duo-tile__img"><img alt="" width="44" height="44" loading="lazy" decoding="async"></span>' +
          '<span class="duo-tile__txt"><strong></strong><small></small></span>';
        b.querySelector('img').src = img;
        b.querySelector('strong').textContent = a.name;
        var sm = b.querySelector('small');
        sm.textContent = price;
        // the caffeine note: after the price on wide pills, its own line on phones (CSS)
        if (a.note) { var n = document.createElement('span'); n.textContent = a.note; sm.appendChild(n); }
      } else {
        b.innerHTML = '<span class="duo-tile__top"><strong></strong><b></b></span>' + (a.note ? '<span class="duo-tile__sub"></span>' : '');
        b.querySelector('strong').textContent = a.name;
        b.querySelector('b').textContent = price;
        if (a.note) b.querySelector('.duo-tile__sub').textContent = a.note;
      }
      b.addEventListener('click', function () {
        if (b.getAttribute('aria-disabled') === 'true') return;
        self.picked.has(a.handle) ? self.picked.delete(a.handle) : self.picked.add(a.handle);
        // the one she just added gets a soft highlight in "What you're getting"
        self.justAdded = self.picked.has(a.handle) ? a.handle : '';
        if (a.cf && self.picked.has(a.handle)) self.version = 'low';
        self.root.dispatchEvent(new CustomEvent('duo:touched', { bubbles: true }));
        self.render();
      });
      return b;
    }
    function grid(items, cls) {
      var g = document.createElement('div');
      g.className = 'duo-p1g__grid' + (cls ? ' ' + cls : '');
      items.forEach(function (a) { g.appendChild(tile(a)); });
      return g;
    }

    var zero = !!this.root.querySelector('[data-duo-version] [data-zero]');
    var inline = this.chipsBox.hasAttribute('data-inline');
    var rest = PLUS_ONES.filter(function (a) { return !(a.cf && (cfSlot || zero)); });
    // a menu drink: only its menu's Plus Ones, so nothing is left for "+ more"
    if (this.allow.length) rest = rest.filter(function (a) { return !a.cf && self.allow.indexOf(a.handle) > -1; });
    PLUS_ONES.forEach(function (a) { if (a.cf && cfSlot) cfSlot.appendChild(tile(a)); });
    var top = topList.map(function (h) { return rest.filter(function (a) { return a.handle === h; })[0]; }).filter(Boolean);
    var more = rest.filter(function (a) { return top.indexOf(a) < 0; });

    if (inline) {
      var g = grid(top.length ? top : rest, 'duo-p1inline');
      this.chipsBox.appendChild(g);
      if (top.length && more.length) {
        more.forEach(function (a) {
          var t = tile(a);
          t.classList.add('is-extra');
          g.appendChild(t);
        });
        var mb = document.createElement('button');
        mb.type = 'button';
        mb.className = 'duo-p1toggle';
        mb.setAttribute('aria-expanded', 'false');
        mb.innerHTML = '<span class="duo-p1toggle__faces" aria-hidden="true"></span><span data-duo-more-label></span>';
        var faces = mb.firstChild;
        more.forEach(function (a) {
          if (!a.img) return;
          var i = document.createElement('img');
          i.src = a.img; i.alt = ''; i.width = 26; i.height = 26; i.loading = 'lazy'; i.dataset.p1face = a.handle;
          faces.appendChild(i);
        });
        mb.addEventListener('click', function () { self.showMore(mb.getAttribute('aria-expanded') !== 'true'); });
        this.chipsBox.appendChild(mb);
        this.moreBtn = mb;
        this.moreGrid = g;
        this.moreItems = more;
      }
      var facts = document.createElement('ul');
      facts.className = 'duo-p1facts';
      facts.setAttribute('role', 'list');
      facts.setAttribute('aria-live', 'polite');
      // the facts close the step: after the swirl picker when the page has one
      if (this.swirlBox && this.swirlBox.parentNode) this.swirlBox.parentNode.insertBefore(facts, this.swirlBox.nextSibling);
      else this.chipsBox.appendChild(facts);
      this.factsEl = facts;
      this.chipsBox.dataset.drawn = '1';
      return;
    }

    var host = this.chipsBox;
    if (top.length) {
      this.chipsBox.appendChild(grid(top, 'duo-p1top'));
      if (more.length) {
        var det = document.createElement('details');
        det.className = 'duo-p1more';
        det.innerHTML = '<summary><span data-duo-more-label></span><i aria-hidden="true"></i></summary><div class="duo-p1more__body"></div>';
        this.chipsBox.appendChild(det);
        host = det.querySelector('.duo-p1more__body');
        this.moreEl = det;
        this.moreItems = more;
      }
    }
    GROUPS.forEach(function (g) {
      var items = more.filter(function (a) { return (a.group || 'add') === g.key; });
      if (!items.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'duo-p1g';
      wrap.dataset.group = g.key;
      var h = document.createElement('p');
      h.className = 'duo-p1g__h';
      h.textContent = g.label;
      wrap.appendChild(h);
      wrap.appendChild(grid(items));
      host.appendChild(wrap);
    });
    this.chipsBox.dataset.drawn = '1';
  };

  /* Scroll to something she asked to see, only if it is not already on screen. */
  Builder.prototype.goTo = function (el, where) {
    if (!el) return;
    var r = el.getBoundingClientRect(), vh = window.innerHeight || 800;
    // In view = its top edge and first 160 px (a step's header and first row) are on
    // screen, or for 'end' its bottom edge. Wanting the whole step on screen made a
    // 350 to 640 px step glide nearly every time (phone audit, 2026-09-27).
    var seen = where === 'end'
      ? (r.bottom <= vh - 90 && r.bottom >= 160)
      : (r.top >= 70 && r.top + Math.min(r.height, 160) <= vh - 90);
    if (seen) return;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { el.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: where || 'start' }); } catch (e) { el.scrollIntoView(); }
  };
  Builder.prototype.step = function (k) {
    return this.steps.filter(function (st) { return st.dataset.duoStep === String(k); })[0];
  };
  /* Only when she asks ("Next: how many"): the page never scrolls or folds on its
     own after a choice (Paul, 2026-09-28: auto-scroll felt jittery on the phone and
     fought her own scrolling). */
  Builder.prototype.advance = function (from) {
    var next = this.step(from + 1);
    this.goTo(next || this.addBtn, next ? 'start' : 'end');
  };

  /* No hole at the end of a Plus One grid (Paul, 2026-09-27): when the last row is
     not full, the last pill widens to fill it. Pills come and go (Caffeine free hides
     the caffeine ones, "+ more" opens the rest) and phones show 2 a row, laptops 3. */
  Builder.prototype.fillRows = function () {
    Array.prototype.forEach.call(this.root.querySelectorAll('.duo-p1inline'), function (g) {
      var open = g.classList.contains('is-open'), shown = [];
      Array.prototype.forEach.call(g.children, function (c) {
        if (!c.classList.contains('duo-tile') || c.hidden) return;
        if (c.classList.contains('is-extra') && !open) return;
        shown.push(c);
      });
      // Same pills, same last pill, same window as last time: the rows are already
      // right. Reading the grid's columns makes the browser lay the page out in the
      // middle of a tap, so it only happens when something changed (2026-09-28).
      var last = shown[shown.length - 1];
      var key = shown.length + ':' + (last ? last.dataset.p1 || last.dataset.pmp1 || '' : '') + ':' + window.innerWidth;
      if (g.duoRows === key) return;
      g.duoRows = key;
      Array.prototype.forEach.call(g.children, function (c) { if (c.style.gridColumn) c.style.gridColumn = ''; });
      var cols = (window.getComputedStyle(g).gridTemplateColumns || '').split(' ').filter(Boolean).length || 1;
      var left = shown.length % cols;
      if (left && shown.length) shown[shown.length - 1].style.gridColumn = 'span ' + (cols - left + 1);
    });
  };

  Builder.prototype.showMore = function (open) {
    if (!this.moreGrid) return;
    this.moreOpen = !!open;
    this.moreGrid.classList.toggle('is-open', this.moreOpen);
    this.moreBtn.setAttribute('aria-expanded', String(this.moreOpen));
    this.render();
  };

  /* Her drink comes back: from a link (?key=high&p1=filter,aloe&name=School%20Run)
     or from the last drink she saved in this browser for this flavour. */
  Builder.prototype.restore = function () {
    var q = new URLSearchParams(window.location.search);
    var src = null;
    if (q.get('key') || q.get('p1') || q.get('name') || q.get('little') || q.get('n') || q.get('set') || q.get('swirl')) {
      src = { version: q.get('key'), picked: (q.get('p1') || '').split(','), name: q.get('name'), little: q.get('little'), pack: q.get('n'), set: q.get('set'), pm: q.get('pm'), pp: q.get('pp'), swirl: q.get('swirl') };
    } else {
      var s = readStore();
      if (s && s.handle && s.handle === this.handle) src = s;
    }
    if (!src) return;
    if (src.version === 'low' || src.version === 'high') this.version = src.version;
    var n = parseInt(src.pack, 10);
    if ((n === 3 || n === 6) && !this.mixing) this.pack = n;
    if (src.version) this.touchedSteps[1] = true;
    if (src.set && this.setBox && !this.mixing) {
      this.setOn = String(src.set) === '1';
      if (this.setOn) this.mode = 'set';
      if (src.pm) {
        var pmb = this.pmBtns, pms = String(src.pm).split(','), okPm = function (h) { return pmb.some(function (x) { return x.dataset.pm === h; }); };
        if (pms.length === 1) pms = [pms[0], pms[0], pms[0]];
        if (pms.length === 3 && pms.every(okPm)) { this.pmDays = pms; this.pm = pms[0]; }
      }
      if (src.pp != null) { this.pmPicked = new Set(String(src.pp).split(',').filter(Boolean)); }
    }
    if (n === 3 || n === 6 || src.little) this.touchedSteps[3] = true;
    var self = this;
    (src.picked || []).forEach(function (h) {
      if (PLUS_ONES.some(function (a) { return a.handle === h; })) self.picked.add(h);
    });
    if (src.name && this.dnameEl) this.dnameEl.value = String(src.name).slice(0, 24);
    var sw = src.swirl || q.get('swirl');
    if (sw && this.swirlBtns.some(function (x) { return x.dataset.swirl === sw; })) this.swirl = sw;
    var lit = src.little || q.get('little') || '';
    var sel = this.littleSel;
    var has = this.littleBtns.some(function (b) { return b.dataset.little === lit; }) ||
      (sel && Array.prototype.some.call(sel.options, function (o) { return o.value === lit; }));
    if (lit && has) { this.little = lit; if (sel) sel.value = lit; }
  };

  Builder.prototype.bind = function () {
    var self = this;
    this.versionBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        self.version = b.dataset.version;
        // "Caffeine free" = Low Key + the Caffeine free Plus One; plain Low Key drops it.
        var cfh = self.cfHandle();
        if (cfh && self.zeroBtn) {
          if (b.hasAttribute('data-zero')) self.picked.add(cfh); else self.picked.delete(cfh);
        }
        self.root.dataset.version = self.version;
        self.root.dispatchEvent(new CustomEvent('duo:touched', { bubbles: true }));
        self.touchedSteps[1] = true;
        self.render();
      });
    });
    // "Next: how many" takes her to step 3
    var nx = this.root.querySelector('[data-duo-next-step]');
    if (nx) nx.addEventListener('click', function () {
      self.touchedSteps[2] = true;
      self.render();
      self.advance(2);
    });
    // A tap on a choice marks its step as hers (the tick). The flag is set before the
    // button's own handler runs (capture), and the step only renders again if that
    // handler did not: one render per tap, not two (phone audit, 2026-09-27).
    this.steps.forEach(function (st) {
      var seen = 0;
      st.addEventListener('click', function (e) {
        seen = -1;
        if (!e.target.closest('button, input')) return;
        // opening "+ more" or the name field is looking, not deciding
        if (e.target.closest('.duo-p1toggle, [data-duo-name-toggle], [data-duo-kname-toggle], [data-duo-mixit]')) return;
        self.touchedSteps[st.dataset.duoStep] = true;
        seen = self.renders || 0;
      }, true);
      st.addEventListener('click', function () {
        if (seen >= 0 && (self.renders || 0) === seen) self.render();
      });
    });
    this.packBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        self.pack = parseInt(b.dataset.pack, 10) || 1;
        self.root.dispatchEvent(new CustomEvent('duo:touched', { bubbles: true }));
        self.render();
      });
    });
    this.littleBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        self.little = b.dataset.little || '';
        if (self.little) self.lastLittle = self.little;
        self.root.dispatchEvent(new CustomEvent('duo:touched', { bubbles: true }));
        self.render();
      });
    });
    // One for them? one switch: on picks a Little, off is just hers
    if (this.pairBtn) this.pairBtn.addEventListener('click', function () {
      if (self.little) {
        self.lastLittle = self.little;
        self.little = '';
      } else {
        // the Little that matches this drink first (Unbothered -> Little Unbothered)
        var match = self.littleBtns.filter(function (x) { return x.hasAttribute('data-match'); })[0];
        var first = self.littleBtns.filter(function (x) { return x.dataset.little; })[0];
        self.little = self.lastLittle || (match || first ? (match || first).dataset.little : '');
      }
      self.root.dispatchEvent(new CustomEvent('duo:touched', { bubbles: true }));
      self.render();
    });
    if (this.nameToggle && this.dnameEl) this.nameToggle.addEventListener('click', function () {
      self.dnameEl.hidden = false;
      self.nameToggle.hidden = true;
      self.dnameEl.focus();
    });
    if (this.littleSel) this.littleSel.addEventListener('change', function () {
      self.little = self.littleSel.value || '';
      self.root.dispatchEvent(new CustomEvent('duo:touched', { bubbles: true }));
      self.render();
    });
    this.swirlBtns.forEach(function (b) {
      b.addEventListener('click', function () { self.swirl = b.dataset.swirl; self.render(); });
    });
    var stop = this.root.querySelector('[data-duo-mix-stop]');
    if (stop) stop.addEventListener('click', function () {
      writeMix(null);
      self.mixing = null;
      self.mode = 'same';
      self.render();
    });
    if (this.addBtn) this.addBtn.addEventListener('click', function () { self.primary(); });
    if (this.addBtn && this.guest) this.addBtn.addEventListener('pointerdown', warmSignIn, { once: true, passive: true });
    if (this.dnameEl) this.dnameEl.addEventListener('input', function () { self.render(); });
    var qtyBox = this.root.querySelector('[data-duo-qty]');
    if (qtyBox) {
      qtyBox.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b || !self.qtyEl) return;
        self.qtyEl.value = Math.max(1, Math.min(99, self.qty() + (b.dataset.step === '+' ? 1 : -1)));
        self.render();
      });
      qtyBox.addEventListener('change', function () { self.render(); });
    }
    if (this.saveForm) {
      this.saveForm.addEventListener('submit', function () { self.beforeSave(); });
      // Saved means in her cart too (Paul + Kellie, Nov 2): assets/duo.js calls this before Shopify's form
      // check sends the save, so the same lines a member's add puts in go in her cart first. It always
      // resolves: if the cart refuses, the save still goes.
      this.saveForm.duoToCart = function () {
        self.beforeSave();
        return new Promise(function (done) { self.add(done); });
      };
    }
  };

  Builder.prototype.btn = function () {
    var v = this.version;
    return this.versionBtns.filter(function (b) { return b.dataset.version === v && !b.hidden && !b.hasAttribute('data-zero'); })[0]
        || this.versionBtns.filter(function (b) { return !b.hidden && !b.hasAttribute('data-zero'); })[0];
  };

  Builder.prototype.cfHandle = function () {
    var a = PLUS_ONES.filter(function (x) { return x.cf; })[0];
    return a ? a.handle : '';
  };

  Builder.prototype.currentVariant = function () {
    // closed too: a saved drink goes in her cart (Nov 2)
    var b = this.btn();
    return b && b.dataset.variant ? b.dataset.variant : '';
  };

  Builder.prototype.isMix = function () { return !!(this.setBox && this.packBtns.length && this.mode === 'mix' && this.mixHow !== 'surprise' && this.pack > 1); };
  /* Surprise me: our pick, every can a different flavour, at her caffeine level. */
  Builder.prototype.isSurprise = function () {
    return !!(this.setBox && this.packBtns.length && this.mode === 'mix' && this.mixHow === 'surprise' && this.pack > 1 && this.drinks.length && !(this.mixing && this.mixing.cans.length));
  };
  // The cans in the surprise: a 6-pack is one of each flavour (Soft Launch at 0 mg,
  // it has no tea); 3 cans are three different flavours we pick, fixed until her
  // build changes. Each can: its variant, price, name, colour and whether it is 0 mg.
  Builder.prototype.surpriseCans = function () {
    var n = this.pack, v = this.version, zero = this.cf() || this.root.hasAttribute('data-nocaf');
    var can = function (d) {
      if (d.h === 'soft-launch' || !d.high) return d.cf ? { d: d, v: d.cf, zero: true, build: 'Caffeine free' } : null;
      if (zero) return d.low ? { d: d, v: d.low, zero: true, cf: true, build: 'Low Key, caffeine free' } : null;
      var b = d[v]; return b ? { d: d, v: b, zero: false, build: NAME[v] || '' } : null;
    };
    var all = this.drinks.map(can).filter(Boolean);
    if (n === 6) return all;
    var pool = zero ? all : all.filter(function (c) { return !c.zero; });
    var key = n + '|' + v + '|' + zero;
    if (this.surpriseKey !== key || !this.surpriseSet) {
      var hs = pool.map(function (c) { return c.d.h; });
      for (var i = hs.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = hs[i]; hs[i] = hs[j]; hs[j] = t; }
      this.surpriseKey = key; this.surpriseSet = hs.slice(0, n);
    }
    var set = this.surpriseSet;
    return pool.filter(function (c) { return set.indexOf(c.d.h) > -1; });
  };
  Builder.prototype.mixCan = function () { return (this.mixing ? this.mixing.cans.length : 0) + 1; };
  Builder.prototype.mixLast = function () { return this.isMix() && this.mixCan() >= this.pack; };
  /* A Plus One that is not on this drink (its "only" list in snippets/duo-plusones). */
  Builder.prototype.offered = function (a) {
    if (a.only && a.only.split(' ').indexOf(this.handle) < 0) return false;
    // a menu drink offers only its menu's Plus Ones (Caffeine free stays a build choice)
    if (this.allow.length && !a.cf && this.allow.indexOf(a.handle) < 0) return false;
    // Extra kick is a full second kick: High Key only (Paul, Oct 27)
    if (a.build && a.build !== this.version) return false;
    return true;
  };
  Builder.prototype.label = function (a) {
    if (a.handle === 'extra-flavour' && this.swirl) return this.swirl + ' swirl';
    return a.name;
  };
  Builder.prototype.qty = function () {
    if (this.packBtns.length) return this.isMix() ? 1 : this.pack;  // a surprise is the whole pack
    var n = this.qtyEl ? parseInt(this.qtyEl.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : Math.min(n, 99);
  };

  Builder.prototype.extras = function () {
    var self = this;
    return PLUS_ONES.filter(function (a) { return self.picked.has(a.handle); });
  };

  Builder.prototype.cf = function () {
    return PLUS_ONES.some(function (a) { return a.cf && this.picked.has(a.handle); }, this);
  };

  Builder.prototype.baseMg = function () {
    if (this.cf()) return 0;
    var b = this.btn();
    return b ? parseInt(b.dataset.mg || '0', 10) : 0;
  };

  /* Her drink as link params, or '' when she has not changed anything. Used
     when she hops to another flavour and when she shares her drink. */
  Builder.prototype.params = function () {
    var q = new URLSearchParams();
    if (!this.root.hasAttribute('data-nocaf') && this.version !== this.defaultVersion) q.set('key', this.version);
    var p = Array.from(this.picked);
    if (p.length) q.set('p1', p.join(','));
    var n = this.dnameEl ? this.dnameEl.value.trim().slice(0, 24) : '';
    if (n) q.set('name', n);
    if (this.little) q.set('little', this.little);
    if (this.picked.has('extra-flavour') && this.swirl) q.set('swirl', this.swirl);
    if (this.pack > 1 && !this.isMix()) q.set('n', String(this.pack));
    if (this.isSet()) { q.set('set', '1'); if (this.pm) q.set('pm', this.pmDays[0] === this.pmDays[1] && this.pmDays[1] === this.pmDays[2] ? this.pmDays[0] : this.pmDays.join(',')); q.set('pp', Array.from(this.pmPicked).join(',')); }
    return q.toString();
  };

  Builder.prototype.shareUrl = function () {
    var qs = this.params();
    return location.origin + location.pathname + (qs ? '?' + qs : '');
  };

  Builder.prototype.littleBtn = function () {
    var h = this.little;
    if (!h) return null;
    if (this.littleSel) {
      var o = Array.prototype.filter.call(this.littleSel.options, function (x) { return x.value === h; })[0];
      if (o) return o;
    }
    return this.littleBtns.filter(function (b) { return b.dataset.little === h; })[0] || null;
  };

  /* The Little follows the pack: one each, and with a 6-pack the Little six-pack
     (its own product; $5 a can like a single since 2026-10-01). */
  Builder.prototype.littleCost = function (lb, n) {
    if (!lb) return 0;
    n = n || this.qty();
    var six = this.root.dataset.littleSix;
    if (n === 6 && six) return parseInt(this.root.dataset.littleSixPrice || '0', 10);
    return parseInt(lb.dataset.price || '0', 10) * n;
  };

  /* 3 + 3 helpers */
  Builder.prototype.isSet = function () { return !!(this.setBox && this.mode === 'set' && this.pack === 6 && this.pmBtns.length); };
  Builder.prototype.pmBtnFor = function (h) {
    return this.pmBtns.filter(function (x) { return x.dataset.pm === h; })[0] || null;
  };
  Builder.prototype.pmBtn = function () {
    // the caffeine free three are ready when every can has a flavour
    var self = this, all = this.pmDays.map(function (h) { return self.pmBtnFor(h); });
    return all.every(Boolean) ? all[0] : null;
  };
  Builder.prototype.pmExtras = function () {
    var self = this;
    return PLUS_ONES.filter(function (a) { return !a.cf && !a.mg && self.pmPicked.has(a.handle); });
  };
  Builder.prototype.drawSet = function () {
    if (!this.setBox || this.setBox.dataset.drawn) return;
    var self = this, box = this.setBox.querySelector('[data-duo-set-adds]');
    var hs = (box && box.dataset.top || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    hs.forEach(function (h) {
      var a = PLUS_ONES.filter(function (x) { return x.handle === h && !x.mg && !x.cf; })[0];
      if (!a || !box) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'duo-chip duo-tile duo-tile--img';
      b.dataset.pmp1 = a.handle;
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = '<span class="duo-tile__img"><img alt="" width="44" height="44" loading="lazy"></span><span class="duo-tile__txt"><strong></strong><small></small></span>';
      b.querySelector('img').src = a.img || '';
      b.querySelector('strong').textContent = a.name;
      b.querySelector('small').textContent = GUEST ? '' : '+' + money(a.price) + ' each';
      b.addEventListener('click', function () {
        self.pmPicked.has(a.handle) ? self.pmPicked.delete(a.handle) : self.pmPicked.add(a.handle);
        self.render();
      });
      box.appendChild(b);
    });
    // Mix it up? closing it goes back to all the same
    if (this.mixToggle) this.mixToggle.addEventListener('click', function () {
      var open = self.mixOpen || self.mode !== 'same';
      self.mixOpen = !open;
      if (open) { self.mode = 'same'; self.setOn = false; }
      self.render();
    });
    // a tap picks one; the same tap takes it back to all the same
    this.setBox.querySelectorAll('[data-set]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.setOn = self.mode !== 'set';
        self.mode = self.setOn ? 'set' : 'same';
        self.touchedSteps[3] = true;
        self.render();
      });
    });
    this.pmBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (self.pmDay) self.pmDays[self.pmDay - 1] = b.dataset.pm;
        else self.pmDays = [b.dataset.pm, b.dataset.pm, b.dataset.pm];
        self.pm = self.pmDays[0];
        self.render();
      });
    });
    this.setBox.querySelectorAll('[data-pmday]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = parseInt(b.dataset.pmday, 10) || 0;
        self.pmDay = self.pmDay === d ? 0 : d;
        self.render();
      });
    });
    this.setBox.querySelectorAll('[data-mixhow]').forEach(function (b) {
      b.addEventListener('click', function () {
        var how = b.dataset.mixhow === 'surprise' ? 'surprise' : 'pick';
        if (self.mode === 'mix' && self.mixHow === how) self.mode = 'same';
        else { self.mode = 'mix'; self.mixHow = how; self.setOn = false; }
        self.surpriseSet = null;
        self.touchedSteps[3] = true;
        self.render();
      });
    });
    this.setBox.dataset.drawn = '1';
  };

  Builder.prototype.saved = function () {
    var ok = this.saveForm && this.saveForm.querySelector('[data-duo-ok]');
    return !!(ok && !ok.hidden);
  };

  /* The Plus Ones already in her cart: how many, and the lowest price among them.
     The drink she is changing does not count: it is about to be replaced. */
  Builder.prototype.readCart = function () {
    if (!this.offer) return Promise.resolve();
    var self = this;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = 0, m = 0;
        (c.items || []).forEach(function (i) {
          if (i.product_type !== 'Plus One') return;
          if (self.editId && i.properties && i.properties._build === self.editId) return;
          var pr = i.original_price || i.price || 0;
          if (!pr || !i.quantity) return;
          n += i.quantity;
          if (!m || pr < m) m = pr;
        });
        self.cartP1 = { n: n, m: m };
        self.render();
      })
      .catch(function () { /* the cart still applies the saving */ });
  };

  /* What this add changes: Shopify takes the lowest-priced Plus One off an order with
     three or more, once. units = [[price in cents, quantity], ...] about to be added.
     off can be below zero: a cheaper Plus One becomes the one on us. */
  Builder.prototype.p1Bonus = function (units) {
    var e = this.cartP1 || { n: 0, m: 0 }, n = 0, m = 0;
    if (!this.offer) return { off: 0, units: 0, mine: 0 };
    units.forEach(function (u) { if (u[0] > 0 && u[1] > 0) { n += u[1]; if (!m || u[0] < m) m = u[0]; } });
    var before = e.n >= 3 ? e.m : 0;
    var low = e.n && n ? Math.min(e.m, m) : (e.n ? e.m : m);
    var after = e.n + n >= 3 ? low : 0;
    return { off: n ? after - before : 0, units: e.n + n, mine: n };
  };

  Builder.prototype.render = function () {
    var self = this;
    this.renders = (this.renders || 0) + 1;
    // Caffeine free only exists on Low Key; picking High Key drops it. A drink
    // with no tea at all (Soft Launch) has nothing to take out.
    if (this.version !== 'low' || this.root.hasAttribute('data-nocaf')) PLUS_ONES.forEach(function (a) { if (a.cf) self.picked.delete(a.handle); });
    // nothing she cannot have on this drink stays picked (a link from another flavour)
    PLUS_ONES.forEach(function (a) { if (!self.offered(a)) self.picked.delete(a.handle); });
    var b = this.btn();
    if (b) this.version = b.dataset.version;
    var off = this.cf() || this.root.hasAttribute('data-nocaf');
    // A drink whose caffeine is not confirmed yet (the monthly Plot Twist) shows
    // no number and takes no caffeinated Plus Ones until it is.
    var unknown = this.root.hasAttribute('data-nomg');

    // A caffeine free drink takes nothing caffeinated.
    if (off || unknown) PLUS_ONES.forEach(function (a) { if (a.mg) self.picked.delete(a.handle); });

    // Drop anything that no longer fits under the cap (switching Low to High).
    var mg = this.baseMg();
    this.extras().forEach(function (a) {
      if (a.mg && mg + a.mg > self.cap) self.picked.delete(a.handle); else mg += a.mg || 0;
    });

    var isCf = this.cf();
    this.versionBtns.forEach(function (x) {
      // Low Key and Caffeine free share version "low": only one of them is lit.
      var on = x.dataset.version === self.version;
      if (on && self.zeroBtn) on = x.hasAttribute('data-zero') ? isCf : !isCf;
      x.setAttribute('aria-pressed', String(on));
    });

    Array.prototype.forEach.call(this.root.querySelectorAll('[data-p1]'), function (c) {
      var a = PLUS_ONES.filter(function (x) { return x.handle === c.dataset.p1; })[0];
      if (!a) return;
      var on = self.picked.has(a.handle);
      c.hidden = !!(a.mg && (off || unknown)) || !!(a.cf && (self.version !== 'low' || self.root.hasAttribute('data-nocaf'))) || !self.offered(a);
      var over = !on && a.mg && mg + a.mg > self.cap;
      c.setAttribute('aria-disabled', over ? 'true' : 'false');
      c.title = over ? 'That would take this drink over ' + self.cap + ' mg of caffeine' : '';
      // on a phone there is no hover, so the pill itself says why it is greyed out
      var ns = c.querySelector('.duo-tile__txt small span');
      if (ns) ns.textContent = over ? 'Over the ' + self.cap + ' mg cap' : a.note;
      c.setAttribute('aria-pressed', String(on));
    });
    if (this.allow.length && this.chipsBox) {
      var pg = this.chipsBox.querySelector('.duo-p1inline');
      if (pg) {
        var vis = Array.prototype.filter.call(pg.children, function (c) { c.classList.remove('is-span'); return !c.hidden; });
        pg.dataset.n = String(vis.length);
        if (vis.length % 2) vis[vis.length - 1].classList.add('is-span');
      }
    }
    if (this.moreBtn) {
      var hidden = this.moreItems.filter(function (a) {
        var c = self.root.querySelector('[data-p1="' + a.handle + '"]'); return c && !c.hidden;
      });
      // something she picked is in the hidden part (from a link or a saved drink): open it
      if (!this.moreOpen && !this.moreAuto && this.moreItems.some(function (a) { return self.picked.has(a.handle); })) {
        this.moreAuto = true; this.moreOpen = true; this.moreGrid.classList.add('is-open'); this.moreBtn.setAttribute('aria-expanded', 'true');
      }
      var ml = this.moreBtn.querySelector('[data-duo-more-label]');
      if (ml) ml.textContent = this.moreOpen ? 'Show less' : '+ ' + hidden.length + ' more';
      Array.prototype.forEach.call(this.moreBtn.querySelectorAll('[data-p1face]'), function (i) {
        i.hidden = !hidden.some(function (a) { return a.handle === i.dataset.p1face; });
      });
      this.moreBtn.hidden = !hidden.length;
    }
    if (this.moreEl) {
      var inMore = this.moreItems.filter(function (a) { return self.picked.has(a.handle); }).length;
      var shown = this.moreItems.filter(function (a) {
        var c = self.root.querySelector('[data-p1="' + a.handle + '"]'); return c && !c.hidden;
      }).length;
      var lab = this.moreEl.querySelector('[data-duo-more-label]');
      if (lab) lab.textContent = 'More Plus Ones (' + shown + ')' + (inMore ? ' · ' + inMore + ' added' : '');
      if (inMore && !this.moreOpened) { this.moreEl.open = true; this.moreOpened = true; }
    }
    // A group with nothing left to show hides its heading too.
    Array.prototype.forEach.call(this.root.querySelectorAll('.duo-p1g'), function (g) {
      var any = Array.prototype.some.call(g.querySelectorAll('[data-p1]'), function (c) { return !c.hidden; });
      g.hidden = !any;
    });

    var extras = this.extras();
    this.packBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(parseInt(x.dataset.pack, 10) === self.pack)); });
    if (this.factsEl) {
      /* What you're getting (Paul, 2026-09-27): every Plus One she adds explains
         itself: what it is, and where Canada allows it, what it does, in the exact
         wording Health Canada accepts (snippets/duo-plusones.liquid). */
      var fx = extras.filter(function (a) { return !a.cf && (a.fact || a.warn); });
      this.factsEl.innerHTML = '';
      if (fx.length) {
        var hd = document.createElement('li');
        hd.className = 'duo-p1facts__h';
        hd.textContent = 'What you\u2019re getting';
        this.factsEl.appendChild(hd);
      }
      fx.forEach(function (a) {
        var li = document.createElement('li');
        li.className = 'duo-p1facts__i' + (a.handle === self.justAdded ? ' is-new' : '');
        li.innerHTML = '<span class="duo-p1facts__img"></span><span class="duo-p1facts__txt"><b></b><span></span></span>';
        if (a.img) {
          var im = document.createElement('img');
          // not lazy: the row is only ever made when it is about to show
          im.src = a.img; im.alt = ''; im.width = 36; im.height = 36;
          li.firstChild.appendChild(im);
        }
        var tx = li.lastChild;
        tx.firstChild.textContent = self.label(a);
        tx.lastChild.textContent = a.fact || '';
        if (a.warn) { var w = document.createElement('strong'); w.textContent = a.warn; tx.appendChild(w); }
        self.factsEl.appendChild(li);
      });
      this.justAdded = '';
      this.factsEl.hidden = !fx.length;
    }
    var each = b ? parseInt(b.dataset.price || '0', 10) : 0;
    extras.forEach(function (a) { each += a.price; });
    var n = this.qty();
    // the pack she is building: while mixing she adds one can at a time, and the
    // pack price (a few dollars off each can) is what each can will cost in the cart
    var mixOn = this.isMix(), packN = this.packBtns.length ? this.pack : n;
    var perCan = each - (this.packBtns.length ? (this.packOff[packN] || 0) : 0);
    var total = perCan * n;
    // the swirl's second flavour
    if (this.swirlBox) this.swirlBox.hidden = !this.picked.has('extra-flavour');
    this.swirlBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.swirl === self.swirl)); });
    if (this.swirlNameEl) this.swirlNameEl.textContent = this.swirl;
    // 3 + 3: three of this build + three caffeine free (0 mg), same 6-pack saving on all six
    var isSet = this.isSet(), pmB = this.pmBtn(), pmTotal = 0, pmX = this.pmExtras();
    var pmAll = this.pmDays.map(function (h) { return self.pmBtnFor(h); });
    var pmSame = this.pmDays[0] === this.pmDays[1] && this.pmDays[1] === this.pmDays[2];
    if (this.setBox) {
      // 3 + 3 needs six; once she has started mixing the choice is made
      if (this.mode === 'set' && (packN !== 6 || !this.pmBtns.length)) { this.mode = 'same'; this.setOn = false; }
      var started = !!(this.mixing && this.mixing.cans.length);
      // changing a drink from the cart keeps it one build: no 3 + 3, no mix
      if (this.editId && this.mode !== 'same') { this.mode = 'same'; this.setOn = false; }
      this.setBox.hidden = packN === 1 || started || !!this.editId;
      var mixShown = !!(this.mixOpen || this.mode !== 'same');
      if (this.mixToggle) this.mixToggle.setAttribute('aria-expanded', String(mixShown));
      if (this.mixPanel) this.mixPanel.hidden = !mixShown;
      this.setBox.querySelectorAll('[data-set]').forEach(function (x) {
        x.hidden = packN !== 6;
        x.setAttribute('aria-pressed', String(self.mode === 'set'));
      });
      // Surprise me needs the list of drinks; the row is as wide as the choices that show
      this.setBox.querySelectorAll('[data-mixhow]').forEach(function (x) {
        x.hidden = x.dataset.mixhow === 'surprise' && !self.drinks.length;
        x.setAttribute('aria-pressed', String(self.mode === 'mix' && x.dataset.mixhow === self.mixHow));
      });
      var segM = this.setBox.querySelector('.duo-seg--modes');
      if (segM) segM.dataset.n = String(Array.prototype.filter.call(segM.children, function (x) { return !x.hidden; }).length);
      var pmPanel = this.setBox.querySelector('[data-duo-set-pm]');
      if (pmPanel) pmPanel.hidden = !isSet;
      // a flavour is lit for the day she is changing, or for all three when they match
      var pmLit = this.pmDay ? this.pmDays[this.pmDay - 1] : (pmSame ? this.pmDays[0] : '');
      this.pmBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.pm === pmLit)); });
      this.setBox.querySelectorAll('[data-pmday]').forEach(function (x) { x.setAttribute('aria-pressed', String(parseInt(x.dataset.pmday, 10) === self.pmDay)); });
      this.setBox.querySelectorAll('[data-pmp1]').forEach(function (x) { x.setAttribute('aria-pressed', String(self.pmPicked.has(x.dataset.pmp1))); });
      this.setBox.querySelectorAll('[data-set-pmimg]').forEach(function (im) {
        var pb = pmAll[(parseInt(im.dataset.day, 10) || 1) - 1];
        if (pb && pb.dataset.fruit && im.getAttribute('src') !== pb.dataset.fruit) im.src = pb.dataset.fruit;
      });
      var hint = this.setBox.querySelector('[data-duo-set-hint]');
      if (hint) hint.textContent = this.pmDay
        ? 'Can ' + this.pmDay + ': pick its flavour. Tap Can ' + this.pmDay + ' again to change all three.'
        : '0 mg caffeine. Tap a can to change just that one.';
      // A paid Plus One that starts switched on says its full cost in words (Collagen
      // is pre-added to the caffeine free cans): "Collagen in all three caffeine free cans, +$12."
      var sn = this.setBox.querySelector('[data-duo-set-name]');
      if (sn) {
        var pmCost = pmX.reduce(function (t, a) { return t + a.price; }, 0) * 3;
        var pmNames = [];
        pmAll.forEach(function (b) { if (b && pmNames.indexOf(b.dataset.name) < 0) pmNames.push(b.dataset.name); });
        var pmList = pmNames.length > 1 ? pmNames.slice(0, -1).join(', ') + ' and ' + pmNames[pmNames.length - 1] : pmNames[0];
        sn.textContent = !pmB ? '' : pmList + ', caffeine free.' + (pmX.length
          ? ' ' + pmX.map(function (a) { return a.name; }).join(' and ') + ' in all three caffeine free cans' + (GUEST ? '' : ', +' + money(pmCost)) + '. Tap to take ' + (pmX.length > 1 ? 'them' : 'it') + ' off.'
          : '');
      }
    }
    if (isSet && pmB) {
      pmTotal = pmAll.reduce(function (t, b) { return t + parseInt(b.dataset.price || '0', 10); }, 0) +
        (pmX.reduce(function (t, a) { return t + a.price; }, 0) - (this.packOff[6] || 0)) * 3;
      total = perCan * 3 + pmTotal;
    }
    // Surprise me: every can its own flavour; her Plus Ones go in every can (the
    // caffeine ones only where the can has caffeine)
    var surp = this.isSurprise() ? this.surpriseCans() : null, sTotal = 0;
    if (surp) {
      var sAdds = extras.filter(function (a) { return !a.cf; });
      surp.forEach(function (c) {
        sTotal += c.v[1] - (self.packOff[packN] || 0) + sAdds.filter(function (a) { return !(c.zero && a.mg); }).reduce(function (t, a) { return t + a.price; }, 0);
      });
      total = sTotal;
    }
    this.surp = surp;
    if (this.setBox) {
      var mhs = this.setBox.querySelector('[data-mixhow-sub]');
      if (mhs) mhs.textContent = packN === 6 ? 'one of each flavour' : 'our pick, all different';
      // one line: the button already says what she gets
      var sno = this.setBox.querySelector('[data-duo-surprise-note]');
      if (sno) {
        var snoTxt = '';
        if (surp) {
          var zeroAll = surp.every(function (c) { return c.zero; });
          snoTxt = [
            zeroAll ? 'All 0 mg caffeine.' : packN === 6 ? 'Soft Launch is 0 mg.' : 'All ' + (NAME[this.version] || '') + '.',
            sAdds.length ? 'Your Plus Ones go in every can.' : ''
          ].filter(Boolean).join(' ');
        }
        sno.textContent = snoTxt;
        sno.hidden = !snoTxt;
      }
    }
    // while mixing, "One for them?" comes with the last can (a Little for each can, or the Little six)
    var littleN = mixOn ? packN : n;
    if (this.littleBox) this.littleBox.hidden = (mixOn && !this.mixLast()) || !!this.editId;
    var lb = (mixOn && !this.mixLast()) || this.editId ? null : this.littleBtn();
    total += this.littleCost(lb, littleN);
    // a Plus One on us: the Plus One units this add puts in the cart, and what that changes
    var paid = extras.filter(function (a) { return !a.cf && a.id && a.price > 0; }), units = [];
    if (surp) {
      surp.forEach(function (c) { paid.forEach(function (a) { if (!(c.zero && a.mg)) units.push([a.price, 1]); }); });
    } else if (isSet && pmB) {
      paid.forEach(function (a) { units.push([a.price, 3]); });
      pmX.forEach(function (a) { if (a.id && a.price > 0) units.push([a.price, 3]); });
    } else {
      paid.forEach(function (a) { units.push([a.price, n]); });
    }
    var bonus = this.p1Bonus(units);
    total -= bonus.off;
    this.bonus = bonus;
    if (this.factsEl && bonus.off > 0) {
      var bl = document.createElement('li');
      bl.className = 'duo-p1facts__offer';
      bl.textContent = 'One Plus One is on us: the lowest-priced one in your order. Once per order.';
      this.factsEl.appendChild(bl);
      this.factsEl.hidden = false;
    }
    // each pack button shows its total, the can price (the old one struck
    // through) and the saving on the cans as a percentage, rounded DOWN so it
    // is never overstated. The saving comes off the can, never the Plus Ones.
    var eachFull = each;
    var base = b ? parseInt(b.dataset.price || '0', 10) : 0;
    this.packBtns.forEach(function (x) {
      var k = parseInt(x.dataset.pack, 10) || 1;
      var off = self.packOff[k] || 0;
      var t = x.querySelector('[data-pack-total]'), e = x.querySelector('[data-pack-each]'), sv = x.querySelector('[data-pack-save]');
      // each pack shows what it would cost with her Plus Ones, the one on us taken off
      var bk = k === packN ? bonus.off : self.p1Bonus(paid.map(function (a) { return [a.price, k]; })).off;
      if (t) t.textContent = money((surp && k === packN ? sTotal : k === 6 && isSet && pmB ? (eachFull - off) * 3 + pmTotal : (eachFull - off) * k) - bk);
      if (e) {
        e.innerHTML = '';
        // one price per can: the can price only shows beside a pack discount, if one is ever set again
        if (k > 1 && !GUEST && off) {
          if (base) { var st = document.createElement('s'); st.textContent = money(base); e.appendChild(st); }
          e.appendChild(document.createTextNode(money(base - off) + ' a can'));
        }
      }
      if (sv) {
        var pct = base ? Math.floor(off / base * 100) : 0;
        sv.hidden = GUEST || !pct;
        // a visitor's page never holds the word or a percent, not even in a hidden tag (members-only prices)
        sv.textContent = sv.hidden ? '' : 'Save ' + pct + '%';
      }
      // "Delivery on us" on the 6 (2026-10-01), for visitors too; it steps aside if a Save % ever shows
      var tg = x.querySelector('[data-pack-tag]');
      if (tg) tg.hidden = !!(sv && !sv.hidden);
    });
    if (this.perkEl) {
      var offN = (this.packOff[packN] || 0) * packN;
      // six cans: the delivery line (public), unless a members' line is set; the old pack lines only if a discount is set
      var line = packN === 6 ? ((GUEST ? '' : this.perkEl.dataset.perk6) || this.perkEl.dataset.perk6Del || (!GUEST && base && offN >= base ? 'Your 6th can is on us.' : '')) :
                 packN === 3 ? ((GUEST ? '' : this.perkEl.dataset.perk3) || (!GUEST && offN ? 'You save ' + money(offN) + ' on the cans.' : '') || this.perkEl.dataset.perk3Del || '') : '';
      this.perkEl.textContent = line;
    }
    this.littleBtns.forEach(function (x) {
      x.setAttribute('aria-pressed', String((x.dataset.little || '') === self.little));
    });

    // Recipe, written the way the drink is made: flavour, build, then + each Plus One.
    var head = [this.root.dataset.name || '', this.buildName || (this.root.hasAttribute('data-nocaf') ? '' : NAME[this.version] || '')].filter(Boolean).join(' · ');
    var recipe = [head].concat(extras.map(function (a) { return self.label(a); })).join(' + ');
    var littleName = lb ? (lb.dataset.name || '') : '';
    var dname = this.dnameEl ? this.dnameEl.value.trim() : '';
    if (isSet && pmB) {
      var eveNames = pmSame ? '3 x ' + pmB.dataset.name : pmAll.map(function (b) { return b.dataset.name; }).join(', ');
      recipe = '3 x ' + recipe + ', and ' + eveNames + ' · Caffeine free' + pmX.map(function (a) { return ' + ' + a.name; }).join('');
    } else if (surp) {
      recipe = 'Surprise me: ' + packN + ' cans, ' + (packN === 6 ? 'one of each flavour' : 'all different') + ' · ' +
        [surp.every(function (c) { return c.zero; }) ? 'Caffeine free' : (NAME[this.version] || '')].concat(extras.filter(function (a) { return !a.cf; }).map(function (a) { return self.label(a); })).join(' + ');
    } else if (n > 1) recipe = n + ' x ' + recipe;
    if (this.recipeEl) this.recipeEl.textContent = recipe + (littleName ? '. And for them: ' + littleName : '');
    if (this.priceEl) this.priceEl.textContent = money(total);
    if (this.btnPriceEl) {
      var was = this.btnPriceEl.textContent, now = money(total);
      this.btnPriceEl.textContent = now;
      // a small bump every time the total changes: the drink is getting built.
      // Not on the first render: the page arrives with the default total already
      // written in (2026-09-28), and a restored build is not her tap.
      if (was && was !== now && this.renders > 1) {
        // Web Animations: no class toggle, so no forced layout on every tap
        if (this.btnPriceEl.animate && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
          this.btnPriceEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)', offset: 0.4 }, { transform: 'scale(1)' }], { duration: 350, easing: 'cubic-bezier(.2,.8,.2,1)' });
        }
      }
    }
    var mgText = unknown ? (off ? '0 mg caffeine' : '') : mg === 0 ? '0 mg caffeine' : 'About ' + Math.round(mg) + ' mg caffeine';
    if (this.mgEl) this.mgEl.textContent = mgText;
    if (this.meterEl) {
      this.meterEl.hidden = unknown;
      var fill = this.meterEl.firstElementChild;
      if (fill) fill.style.width = Math.min(100, (mg / this.cap) * 100) + '%';
      this.meterEl.setAttribute('aria-valuenow', String(Math.round(mg)));
    }
    // v3 (Oct 28): the meter's number, "~50 of 180 mg" (0 mg is exact)
    if (this.mgOfEl) this.mgOfEl.textContent = unknown ? '' : (mg > 0 ? '~' : '') + Math.round(mg) + ' of ' + this.cap + ' mg';
    this.mg = mg;
    this.recipe = recipe;
    this.total = total;

    var adds = extras.filter(function (a) { return !a.cf; });
    if (this.addonsLabel) {
      this.addonsLabel.textContent = adds.length ? adds.map(function (a) { return self.label(a); }).join(', ') : (this.addonsLabel.dataset.default || 'Add Plus Ones');
      this.addonsLabel.classList.toggle('is-set', !!adds.length);
    }
    if (this.p1SumEl) {
      var addSum = adds.reduce(function (n, a) { return n + a.price; }, 0);
      this.p1SumEl.textContent = addSum && !GUEST ? '+' + money(addSum) : '';
    }
    if (this.mgShortEl) this.mgShortEl.textContent = unknown ? '' : Math.round(mg) + ' mg';
    var solo = (surp ? sTotal : isSet && pmB ? total + bonus.off - this.littleCost(lb, n) : perCan * n) - bonus.off;
    if (this.soloPriceEl) this.soloPriceEl.textContent = money(solo);
    if (this.pairPriceEl) {
      var pl = lb || this.littleBtns.filter(function (x) { return x.dataset.little; })[0];
      this.pairPriceEl.textContent = GUEST ? '' : '+' + money(this.littleCost(pl, littleN));
    }
    if (this.pairBtn) this.pairBtn.setAttribute('aria-checked', String(!!this.little));
    if (this.littleRow) this.littleRow.hidden = !this.little;
    var ln = this.root.querySelector('[data-duo-little-name]');
    if (ln) {
      var single = lb ? parseInt(lb.dataset.price || '0', 10) : 0;
      ln.textContent = !lb ? '' : littleN === 6 && this.root.dataset.littleSix
        ? GUEST ? lb.dataset.name + ' x 6, the Little six-pack' : lb.dataset.name + ' x 6 for ' + money(this.littleCost(lb, 6)) + '.' + (this.littleCost(lb, 6) < single * 6 ? ' Six singles are ' + money(single * 6) + '.' : '')
        : littleN > 1 ? lb.dataset.name + ' x ' + littleN : lb.dataset.name;
    }
    if (this.dnameEl && this.nameToggle && this.dnameEl.value.trim()) { this.dnameEl.hidden = false; this.nameToggle.hidden = true; }

    // step summaries: one line each, what she has picked
    var buildName = this.buildName ? this.buildName + (this.cf() ? ', caffeine free' : '') : (off && !unknown) ? 'Caffeine free' : (NAME[this.version] || '');
    if (this.sum1) this.sum1.textContent = [this.root.dataset.name || '', buildName].filter(Boolean).join(' · ');
    if (this.sum2) {
      var s2 = adds.length ? (adds.length === 1 ? this.label(adds[0]) : adds.length + ' added') : (dname ? '"' + dname + '"' : 'Optional');
      // the Plus One on us: how far she is, or what came off
      if (this.offer) {
        var left = 3 - bonus.units;
        if (bonus.off > 0) s2 += ' · ' + money(bonus.off) + ' on us';
        else if (left > 0 && adds.length) s2 += ' · ' + left + ' more, one is on us';
        else if (left > 0 && !dname) s2 = left === 3 ? 'Add 3 Plus Ones, one is on us' : left + ' more Plus One' + (left > 1 ? 's' : '') + ', one is on us';
      }
      this.sum2.textContent = s2;
    }
    if (this.sum3) {
      var pk = surp ? 'Surprise me · ' + packN + ' cans' : mixOn ? 'Mix and match · can ' + this.mixCan() + ' of ' + packN
        : n === 6 ? (isSet ? (this.setBox.querySelector('[data-set="1"] b') || { textContent: '3 + 3' }).textContent : '6-pack') : n === 3 ? '3 cans' : '1 can';
      var sv3 = this.packBtns.filter(function (x) { return parseInt(x.dataset.pack, 10) === n; })[0];
      var svEl = sv3 && sv3.querySelector('[data-pack-save]');
      if (svEl && !svEl.hidden) pk += ' · ' + svEl.textContent;
      if (lb) pk += ' + Little DUO';
      this.sum3.textContent = pk;
    }
    // a step is done once she made it hers; moving on to a later step accepts the earlier ones
    var t = this.touchedSteps;
    var d3 = !!(t[3] || packN > 1 || lb), d2 = !!(adds.length || dname || t[2]), d1 = !!(t[1] || t[2] || d2 || d3);
    this.steps.forEach(function (st) {
      var k = st.dataset.duoStep;
      st.classList.toggle('is-done', k === '1' ? d1 : k === '2' ? d2 : d3);
    });

    var label, disabled = false;
    if (this.closed) {
      if (this.saved()) { label = 'Saved'; disabled = true; }
      else if (mixOn && !this.mixLast()) label = 'Save can ' + this.mixCan() + ' of ' + packN;
      else label = 'Save my drink';
    } else if (this.guest) {
      label = this.busy ? 'Saving your drink' : 'See your price';
      disabled = !this.currentVariant();
    } else {
      label = this.addBtn ? (this.addBtn.dataset.label || 'Add to cart') : 'Add to cart';
      if (mixOn) label = 'Add can ' + this.mixCan() + ' of ' + packN;
      if (surp) label = 'Add ' + packN + ' cans';
      if (this.editId && !mixOn && !surp) label = 'Update my drink';
      disabled = !this.currentVariant();
    }
    this.drawMix(packN);
    this.fillRows();
    if (this.addBtn) {
      this.addBtn.disabled = disabled;
      var lab = this.addBtn.querySelector('[data-duo-label]');
      if (lab) lab.textContent = label;
    }
    if (this.noteEl) {
      this.noteEl.textContent = this.closed && !this.saved() ? (this.noteEl.dataset.soon || '') : '';
    }
    if (this.saved()) this.root.classList.add('is-saving');
    this.paintSticky(label, disabled, mgText, dname);
    this.paintHops();
  };

  /* The flavour dots carry her build in their own link (2026-09-28), so a browser
     that fetches a page before the tap lands (snippets/duo-head.liquid) fetches
     the one she is about to open. */
  Builder.prototype.paintHops = function () {
    var qs = this.params();
    Array.prototype.forEach.call(this.root.querySelectorAll('a[data-duo-hop]'), function (a) {
      var base = a.dataset.base || (a.dataset.base = (a.getAttribute('href') || '').split('?')[0]);
      var h = qs ? base + '?' + qs : base;
      if (a.getAttribute('href') !== h) a.setAttribute('href', h);
    });
  };

  /* The mix tracker: one dot per can, filled in the drink's colour once it is in. */
  Builder.prototype.drawMix = function (packN) {
    if (!this.mixBox) return;
    var on = this.isMix();
    this.mixBox.hidden = !on;
    if (this.packFs) this.packFs.hidden = !!(this.mixing && this.mixing.cans.length);
    if (!on) return;
    var cans = this.mixing ? this.mixing.cans : [], k = cans.length + 1;
    var title = this.mixBox.querySelector('[data-duo-mix-title]'), dots = this.mixBox.querySelector('[data-duo-mix-cans]'), sub = this.mixBox.querySelector('[data-duo-mix-sub]');
    if (title) title.textContent = packN === 6 ? 'Your 6-pack, mixed' : 'Your ' + packN + ' cans, mixed';
    if (dots) {
      dots.innerHTML = '';
      for (var i = 0; i < packN; i++) {
        var d = document.createElement('i');
        if (i < cans.length) { d.className = 'is-in'; d.style.background = cans[i].c || '#1A1A1A'; d.title = cans[i].name; }
        else if (i === cans.length) d.className = 'is-now';
        dots.appendChild(d);
      }
    }
    var off = this.packOff[packN] || 0;
    if (sub) sub.textContent = 'Can ' + k + ' of ' + packN + (cans.length ? ': keep this one or tap another flavour.' : ': build it, add it, then the next.') +
      (off && !GUEST ? ' Each can is ' + money(off) + ' less once all ' + packN + ' are in.' : '');
  };

  Builder.prototype.paintSticky = function (label, disabled, mgText, dname) {
    var bar = document.querySelector('[data-duo-sticky]');
    if (!bar || (bar.duoOwner && bar.duoOwner !== this)) return;
    bar.duoOwner = this;
    var r = bar.querySelector('[data-duo-sticky-recipe]');
    var m = bar.querySelector('[data-duo-sticky-meta]');
    var btn = bar.querySelector('[data-duo-sticky-btn]');
    if (r) r.textContent = dname ? '"' + dname + '"' : this.recipe;
    if (m) m.textContent = [mgText, money(this.total)].filter(Boolean).join(' · ');
    if (btn) {
      btn.textContent = label;
      btn.disabled = disabled;
      if (!btn.dataset.bound) {
        btn.dataset.bound = '1';
        var self = this;
        if (self.guest) btn.addEventListener('pointerdown', warmSignIn, { once: true, passive: true });
        btn.addEventListener('click', function () {
          if (self.closed && !(self.isMix() && !self.mixLast())) {
            self.openSave();
            var panel = self.saveForm && self.saveForm.closest('[data-duo-save-panel]');
            (panel || self.root).scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            self.primary();
          }
        });
      }
    }
  };

  Builder.prototype.primary = function () {
    if (this.closed && this.isMix() && !this.mixLast()) this.add(function () {});
    else if (this.closed) this.openSave();
    else this.add();
  };

  Builder.prototype.openSave = function (arrived) {
    if (!this.saveForm) {
      if (this.noteEl) this.noteEl.textContent = this.noteEl.dataset.soon || '';
      return;
    }
    var panel = this.saveForm.closest('[data-duo-save-panel]') || this.saveForm;
    panel.hidden = false;
    this.root.classList.add('is-saving');
    if (!arrived && panel.hasAttribute('data-duo-onetap') && this.saveForm.requestSubmit) { this.saveForm.requestSubmit(); return; }
    var i = this.saveForm.querySelector('input[type=email]');
    if (i) setTimeout(function () { i.focus({ preventScroll: false }); }, 250);
  };

  /* Right before the customer form posts: write the build into the tags and
     keep a copy in this browser. */
  Builder.prototype.beforeSave = function () {
    var tags = ['saved-drink', 'secret-menu', 'newsletter'];
    if (this.handle) tags.push('saved-' + this.handle);
    tags.push('key-' + (this.cf() || this.root.hasAttribute('data-nocaf') ? 'caffeine-free' : this.version));
    this.extras().forEach(function (a) { if (!a.cf) tags.push('p1-' + a.handle); });
    if (this.little) tags.push('little-' + this.little);
    if (this.pack > 1) tags.push('pack-' + this.pack);
    try {
      var zip = localStorage.getItem('duo:zip');
      if (zip) tags.push('fsa-' + zip.slice(0, 3).toLowerCase());
    } catch (e) { /* fine */ }
    var t = this.saveForm.querySelector('[data-duo-save-tags]');
    if (t) t.value = tags.join(',');
    writeStore({
      handle: this.handle,
      version: this.version,
      picked: Array.from(this.picked),
      name: this.dnameEl ? this.dnameEl.value.trim().slice(0, 24) : '',
      little: this.little,
      pack: this.pack,
      recipe: this.recipe,
      at: Date.now()
    });
  };

  Builder.prototype.add = function (onSaved) {
    var saving = typeof onSaved === 'function';
    if (this.closed && !saving) { this.openSave(); return; }
    var variant = this.currentVariant();
    if (!variant || this.busy) { if (saving) onSaved(); return; }
    var self = this;
    // One add at a time: the main button and the bottom bar can both call this.
    this.busy = true;
    var stickyBtn = document.querySelector('[data-duo-sticky-btn]');
    if (stickyBtn) stickyBtn.disabled = true;
    // a saved drink: no sign-in on the way, the save form takes her email
    var guest = this.guest && !saving;
    var labEl = this.addBtn.querySelector('[data-duo-label]');
    var done = function () {
      self.busy = false;
      self.addBtn.classList.remove('is-busy');
      if (stickyBtn) stickyBtn.disabled = false;
      if (guest && labEl) labEl.textContent = 'See your price';
    };
    // changing a drink from the cart: the new lines take the old drink's _build id, so
    // its Little stays paired, and the old drink and its Plus Ones are taken out first
    var editing = !!this.editId && !this.isMix() && !this.isSurprise() && !this.isSet();
    var id = editing ? this.editId : buildId();
    var recipe = this.recipe || '';
    var extras = this.extras();
    var dname = this.dnameEl ? this.dnameEl.value.trim().slice(0, 24) : '';

    // "Build" shows in the cart only when it says more than the variant already does
    // ("Low Key, caffeine free"). "High Key" under a High Key line is kept private
    // (_Build): the kitchen still reads it from the variant.
    var nocaf = this.root.hasAttribute('data-nocaf');
    var buildTxt = nocaf ? 'Caffeine free' : (NAME[this.version] || '') + (this.cf() ? ', caffeine free' : '');
    var props = {};
    props[!nocaf && this.cf() ? 'Build' : '_Build'] = buildTxt;
    var plusTxt = extras.filter(function (a) { return !a.cf; }).map(function (a) { return self.label(a); }).join(', ');
    if (plusTxt) props['Plus Ones'] = plusTxt;
    if (this.picked.has('extra-flavour') && this.swirl) props['Swirl'] = this.swirl;
    props['Caffeine'] = this.root.hasAttribute('data-nomg') ? 'Not listed yet' : Math.round(this.mg || 0) + ' mg';
    props['_Recipe'] = recipe;
    props['_build'] = id;
    if (dname) props['Drink name'] = dname;

    var q = this.qty();
    var mixOn = this.isMix(), packN = this.pack, can = this.mixCan(), last = this.mixLast();
    if (mixOn) props['Part'] = 'Can ' + can + ' of ' + packN + ', mix and match';
    // 3 + 3: three of this build, then the three caffeine free cans as their own build
    var isSet = this.isSet(), pmB = this.pmBtn();
    var qAm = isSet && pmB ? 3 : q;
    if (isSet && pmB) props['Part'] = 'With caffeine, 3 + 3';
    var swirlOf = function (a) { return a.handle === 'extra-flavour' && self.swirl ? { 'Swirl': self.swirl } : {}; };
    var items, surp = this.surp;
    if (surp) {
      // Surprise me: one line per can, each its own flavour, her Plus Ones in every
      // can (the caffeine ones only where the can has caffeine)
      items = [];
      var sAdds = extras.filter(function (a) { return !a.cf; });
      surp.forEach(function (c) {
        var cid = buildId(), ex = sAdds.filter(function (a) { return !(c.zero && a.mg); });
        var cp = {};
        cp[c.cf ? 'Build' : '_Build'] = c.build;
        if (ex.length) cp['Plus Ones'] = ex.map(function (a) { return self.label(a); }).join(', ');
        if (ex.some(function (a) { return a.handle === 'extra-flavour'; }) && self.swirl) cp['Swirl'] = self.swirl;
        cp['Caffeine'] = c.zero ? '0 mg' : Math.round(self.mg || 0) + ' mg';
        cp['_Recipe'] = c.d.name + ' · ' + c.build + ex.map(function (a) { return ' + ' + self.label(a); }).join('');
        cp['Part'] = 'Surprise me, ' + packN + ' cans';
        cp['_build'] = cid;
        items.push({ id: Number(c.v[0]), quantity: 1, properties: cp });
        ex.forEach(function (a) {
          if (a.id) items.push({ id: Number(a.id), quantity: 1, properties: Object.assign({ 'Mixed into': c.d.name, '_build': cid }, swirlOf(a)) });
        });
      });
    } else {
      items = [{ id: Number(variant), quantity: qAm, properties: props }];
      extras.forEach(function (a) {
        if (!a.id) return;
        items.push({ id: Number(a.id), quantity: qAm, properties: Object.assign({ 'Mixed into': self.root.dataset.name || 'your can', '_build': id }, swirlOf(a)) });
      });
    }
    if (isSet && pmB) {
      // the caffeine free cans, one build per flavour; a flavour on some cans says which cans
      var pmX = this.pmExtras(), groups = {}, order = [];
      this.pmDays.forEach(function (h, i) { if (!groups[h]) { groups[h] = []; order.push(h); } groups[h].push(i + 1); });
      order.forEach(function (h) {
        var eb = self.pmBtnFor(h), days = groups[h], id2 = buildId();
        if (!eb) return;
        var pmProps = {};
        pmProps[eb.hasAttribute('data-cf') ? 'Build' : '_Build'] = eb.hasAttribute('data-cf') ? 'Low Key, caffeine free' : 'Caffeine free';
        items.push({ id: Number(eb.dataset.variant), quantity: days.length, properties: Object.assign(pmProps, {
          'Plus Ones': pmX.map(function (a) { return a.name; }).join(', ') || undefined,
          'Caffeine': '0 mg',
          '_Recipe': eb.dataset.name + ' · Caffeine free' + pmX.map(function (a) { return ' + ' + a.name; }).join(''),
          'Part': 'Caffeine free, 3 + 3' + (days.length < 3 ? ' (can ' + days.join(' and ') + ')' : ''),
          '_build': id2
        }) });
        pmX.forEach(function (a) {
          if (a.id) items.push({ id: Number(a.id), quantity: days.length, properties: { 'Mixed into': eb.dataset.name + ' (caffeine free)', '_build': id2 } });
        });
      });
    }

    // while mixing, the Little comes with the last can, sized to the whole pack
    var lb = (mixOn && !last) || editing ? null : this.littleBtn();
    var lq = mixOn ? packN : q;
    if (lb && lb.dataset.variant) {
      var lProps = { 'Paired with': surp ? 'Surprise me' : this.root.dataset.name || 'your DUO' };
      if (lq === 6 && this.root.dataset.littleSix) lProps['Flavour'] = lb.dataset.name;
      // the kid's first name, for their stickers only (snippets/duo-kname.liquid)
      var kn = this.root.querySelector('[data-duo-kname]');
      var kname = kn ? kn.value.replace(/\s+/g, ' ').trim().slice(0, 14) : '';
      if (kname) lProps['Name for stickers'] = kname;
      lProps['_build'] = id;
      items.push(lq === 6 && this.root.dataset.littleSix
        ? { id: Number(this.root.dataset.littleSix), quantity: 1, properties: lProps }
        : { id: Number(lb.dataset.variant), quantity: lq, properties: lProps });
    }

    this.addBtn.classList.add('is-busy');
    if (guest) { warmSignIn(); if (labEl) labEl.textContent = 'Saving your drink'; }
    var post = function (path, body) {
      return fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
    };
    // changing a drink: take the old drink and its Plus Ones out first (the Little stays).
    // A visitor who taps again before signing in: the drink from her earlier tap comes
    // out the same way, Little and all, so it is replaced, never doubled. While she
    // mixes, each can is its own add and nothing is taken out.
    var old = null;
    var prior = guest ? readPending() : null;
    var drop = editing ? [id] : (prior && !mixOn ? prior.ids : []);
    var pre = !drop.length ? Promise.resolve() : fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var lines = (c.items || []).filter(function (i) { return i.properties && drop.indexOf(i.properties._build) > -1 && (!editing || i.product_type !== 'Little DUO'); });
        if (!lines.length) return;
        var up = {};
        lines.forEach(function (i) { up[i.key] = 0; });
        return post('/cart/update.js', { updates: up }).then(function (r) {
          if (!r.ok) { if (editing) throw new Error('Could not change that drink. Try again.'); return; }
          old = lines;
        });
      });
    if (!editing) pre = pre.catch(function () { /* the add still goes ahead */ });
    pre.then(function () {
      // Shopify puts the newest line at the top of the cart, so the lines go in
      // backwards: the cart then reads drink, its Plus Ones, then the Little.
      // While ordering is off, only a save may add (assets/duo.js lets DUO_SAVING through).
      window.DUO_SAVING = saving;
      var sent = post('/cart/add.js', { items: items.slice().reverse() });
      window.DUO_SAVING = false;
      return sent;
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok && old) {
          // the new build was refused: put her drink back the way it was
          var back = old.map(function (i) { return { id: i.variant_id, quantity: i.quantity, properties: i.properties }; }).reverse();
          old = null;
          return post('/cart/add.js', { items: back }).then(function () { return res; }, function () { return res; });
        }
        return res;
      })
      .then(function (res) {
        // a visitor's button stays busy: the next thing she sees is the sign-in
        if (!res.ok || !guest) done();
        if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'Could not add that');
        document.dispatchEvent(new CustomEvent('duo:added', { detail: { items: items } }));
        // the kid's sticker name stays on the order, never on the device (Paul, 2026-09-29)
        var keep = items.map(function (it) {
          if (!it.properties || !('Name for stickers' in it.properties)) return it;
          var pr = Object.assign({}, it.properties);
          delete pr['Name for stickers'];
          return Object.assign({}, it, { properties: pr });
        });
        if (guest) {
          var ids = [];
          keep.forEach(function (it) { var bid = it.properties && it.properties._build; if (bid && ids.indexOf(bid) < 0) ids.push(bid); });
          var more = prior && mixOn;
          writePending({ ids: (more ? prior.ids : []).concat(ids), items: (more ? prior.items : []).concat(keep.slice().reverse()), at: Date.now() });
        }
        if (saving && !(mixOn && !last)) {
          // saved: the form posts and the page comes back with "Saved"
          if (mixOn) writeMix(null);
          onSaved();
          return;
        }
        if (mixOn && !last) {
          self.nextCan();
          if (saving) return;
          // a visitor signs in after her first can and comes back here to build the next
          if (guest) signIn(location.pathname);
          return;
        }
        if (mixOn) writeMix(null);
        // "Your usual" on this device (assets/duo.js): the same lines, one tap to reorder
        if (!mixOn) try {
          localStorage.setItem('duo:last', JSON.stringify({
            source: 'last', items: keep, recipe: self.recipe, fruit: self.root.dataset.fruit || null,
            little: lb ? (lb.dataset.name || '') : '', url: self.shareUrl().replace(location.origin, ''), at: Date.now()
          }));
        } catch (e) { /* private mode: fine */ }
        if (guest) {
          // her build, should she come back to this page instead of the cart
          writeStore({ handle: self.handle, version: self.version, picked: Array.from(self.picked), name: dname, little: self.little, pack: self.pack, recipe: self.recipe, at: Date.now() });
          signIn('/cart');
          return;
        }
        window.location.href = '/cart';
      })
      .catch(function (err) {
        done();
        if (self.noteEl) self.noteEl.textContent = err.message;
        // the cart said no: her save still goes through
        if (saving && !(mixOn && !last)) onSaved();
      });
  };

  /* Mix and match: this can is in; note it and start a fresh one on the same page.
     She can stay on this flavour or tap another flavour dot (the mix follows her). */
  Builder.prototype.nextCan = function () {
    var m = this.mixing || { n: this.pack, cans: [] };
    var cs = getComputedStyle(this.root.closest('.duo-pdp') || this.root);
    m.cans.push({ name: this.root.dataset.name || '', c: (cs.getPropertyValue('--c') || '').trim() });
    m.n = this.pack;
    this.mixing = m;
    writeMix(m);
    // a fresh can: default build, nothing added, no name
    var self = this;
    this.picked.clear();
    this.version = this.defaultVersion;
    this.root.dataset.version = this.version;
    if (this.dnameEl) { this.dnameEl.value = ''; this.dnameEl.hidden = true; if (this.nameToggle) this.nameToggle.hidden = false; }
    this.touchedSteps = {};
    if (this.moreOpen) this.showMore(false);
    this.render();
    this.readCart();
    if (this.noteEl) this.noteEl.textContent = 'Can ' + m.cans.length + ' of ' + m.n + ' is in your cart. Build can ' + (m.cans.length + 1) + '.';
    var top = this.mixBox || this.root;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { top.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' }); } catch (e) { top.scrollIntoView(); }
    if (this.mixBox && !calm) { this.mixBox.classList.remove('is-flash'); void this.mixBox.offsetWidth; this.mixBox.classList.add('is-flash'); }
    self.root.dispatchEvent(new CustomEvent('duo:touched', { bubbles: true }));
  };

  var fillQueued = false;
  window.addEventListener('resize', function () {
    if (fillQueued) return;
    fillQueued = true;
    window.requestAnimationFrame(function () {
      fillQueued = false;
      Array.prototype.forEach.call(document.querySelectorAll('[data-duo-build]'), function (r) { if (r.duoBuilder) r.duoBuilder.fillRows(); });
    });
  }, { passive: true });

  function init() {
    loadP1();
    Array.prototype.forEach.call(document.querySelectorAll('[data-duo-build]'), function (root) {
      if (root.dataset.duoReady) return;
      root.dataset.duoReady = '1';
      root.duoBuilder = new Builder(root);
    });
  }

  /* Changing flavour in place (Paul, 2026-10-01: "the change in between pages ... fully
     optimized and fast"). A flavour dot used to load a whole new page: about 0.4 s to
     show and 1 s until the Plus Ones worked, at phone speed. Now the other drinks'
     product sections are fetched once the page is quiet (Shopify's section rendering,
     ?section_id=), kept off the page, and swapped in on the tap. Her build
     rides in the address exactly as before (the dot's own link, paintHops), so the
     new builder restores it; the ticks, an open "+ more", a mix she has just chosen
     and the sticker name are carried across by hand. The address, the tab title and
     Back all follow. Anything that cannot be done in place (no fetch, the theme
     editor, a failed or slow request) falls back to the plain link.

     HOP.cache: path -> the drink's <section class="duo-pdp"> in a document of its own
     (never the live page), or the HTML text of the drink the page opened on
     (window.__duoPdp0 = { path, html }, taken by the section before any script
     touched it: Back and the way home need it). */
  var HOP = { cache: {}, wait: {}, warm: {}, busy: false, used: false, warmed: false };
  function pdp() { return document.querySelector('section.duo-pdp'); }
  // the nearest box that really scrolls (Horizon's .page-wrapper on desktop), or null for the page itself
  function scrollerOf(el) {
    for (var n = el && el.parentElement; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var oy = window.getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) return n;
    }
    return null;
  }
  function sectionId() {
    var sec = pdp(), w = sec && sec.closest('.shopify-section');
    return w && w.id ? w.id.replace(/^shopify-section-/, '') : '';
  }
  function pathOf(href) {
    try { return new URL(href, location.href).pathname; } catch (e) { return ''; }
  }
  function parsePdp(html) {
    try { return new DOMParser().parseFromString(html, 'text/html').querySelector('section.duo-pdp'); } catch (e) { return null; }
  }
  function hopCan() {
    if (window.Shopify && window.Shopify.designMode) return false;
    return !!(window.DOMParser && window.fetch && window.history && history.pushState && document.importNode && sectionId());
  }
  function hopSelf() {
    var z = window.__duoPdp0;
    if (z && z.path && z.html && !HOP.cache[z.path]) HOP.cache[z.path] = z.html;
    window.__duoPdp0 = null;
  }
  function getHop(path) {
    hopSelf();
    var c = HOP.cache[path];
    if (typeof c === 'string') { c = parsePdp(c); if (c) HOP.cache[path] = c; else delete HOP.cache[path]; }
    return c || null;
  }
  function fetchHop(path, urgent) {
    if (getHop(path)) return Promise.resolve(HOP.cache[path]);
    if (HOP.wait[path]) return HOP.wait[path];
    var id = sectionId();
    if (!id) return Promise.reject(new Error('no section'));
    var opts = { credentials: 'same-origin', headers: { 'Accept': 'text/html' } };
    if (!urgent) opts.priority = 'low';
    HOP.wait[path] = fetch(path + '?section_id=' + encodeURIComponent(id), opts)
      .then(function (r) { if (!r.ok) throw new Error('hop ' + r.status); return r.text(); })
      .then(function (html) {
        var el = parsePdp(html);
        if (!el || !el.querySelector('[data-duo-build]')) throw new Error('hop: no card');
        HOP.cache[path] = el;
        delete HOP.wait[path];
        return el;
      }, function (e) { delete HOP.wait[path]; throw e; });
    return HOP.wait[path];
  }
  /* The next drink's first photo, fetched ahead with the same srcset and sizes so the
     page finds it already there. */
  function warmLead(path) {
    var el = getHop(path), im = el && el.querySelector('.duo-pdp__stage img.duo-pdp__main');
    if (!im || HOP.warm[path]) return;
    HOP.warm[path] = true;
    var w = new Image();
    w.decoding = 'async';
    try { w.fetchPriority = 'low'; } catch (e) { /* fine */ }
    if (im.getAttribute('sizes')) w.sizes = im.getAttribute('sizes');
    if (im.getAttribute('srcset')) w.srcset = im.getAttribute('srcset');
    w.src = im.getAttribute('src');
  }
  function hopLinks() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-duo-build] a[data-duo-hop]'));
  }
  function hopPath(a) { return pathOf(a.dataset.base || a.getAttribute('href')); }
  /* Once the page is quiet: the other drinks, one at a time, low priority. A laptop
     also gets each first photo; a phone the two drinks beside this one (the rest when
     she touches the dots). Nothing ahead of time with Save-Data on: the tap fetches. */
  function hopWarm() {
    if (HOP.warmed || !document.querySelector('a[data-duo-hop]') || !hopCan()) return;
    HOP.warmed = true;
    hopSelf();
    if (navigator.connection && navigator.connection.saveData) return;
    var links = hopLinks(), i = 0;
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var near = hopNear();
    (function next() {
      if (i >= links.length) return;
      var path = hopPath(links[i++]);
      if (!path) { next(); return; }
      fetchHop(path).then(function () { if (fine || near.indexOf(path) > -1) warmLead(path); }, function () { /* the tap tries again */ })
        .then(function () { window.setTimeout(next, 120); });
    })();
  }
  // the drinks either side of this one in the row of dots
  function hopNear() {
    var nav = document.querySelector('[data-duo-build] [data-duo-step="1"] .duo-swatches');
    var all = nav ? Array.prototype.slice.call(nav.querySelectorAll('a')) : [], out = [];
    var at = -1;
    all.forEach(function (x, k) { if (x.hasAttribute('aria-current')) at = k; });
    if (at < 0 || all.length < 2) return out;
    [all[(at + 1) % all.length], all[(at - 1 + all.length) % all.length]].forEach(function (x) {
      if (x && x.hasAttribute('data-duo-hop')) out.push(hopPath(x));
    });
    return out;
  }
  function hopSoon() {
    var go = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(hopWarm, { timeout: 2500 });
      else window.setTimeout(hopWarm, 900);
    };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }

  /* Put the drink at `path` on the page in place of this one. opts.push: write the
     new address (false when the browser already did: Back). opts.from: the dot she
     tapped. Returns false when it cannot be done here. */
  function hopTo(path, url, opts) {
    var cur = pdp(), el = getHop(path);
    if (!cur || !el) return false;
    var next = document.importNode(el, true);
    var oldRoot = cur.querySelector('[data-duo-build]'), ob = oldRoot && oldRoot.duoBuilder;
    var newRoot = next.querySelector('[data-duo-build]');
    if (!oldRoot || !newRoot) return false;
    var from = opts.from || null;
    var inCard = !!(from && oldRoot.contains(from));
    var hadFocus = !!(from && document.activeElement === from);
    var oldName = oldRoot.dataset.name || '';
    var okn = oldRoot.querySelector('[data-duo-kname]');
    var keep = ob ? { touched: ob.touchedSteps, more: !!ob.moreOpen, mode: ob.mode, mixHow: ob.mixHow, mixOpen: !!ob.mixOpen, pack: ob.pack, started: !!(ob.mixing && ob.mixing.cans.length) } : null;
    // her build as it stands goes on this page's own history entry, so Back shows it again
    if (opts.push && ob && !ob.editId) {
      var qs = ob.params();
      try { history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '')); } catch (e) { /* fine */ }
    }
    // the bottom bar, the paused loops: as they were, so nothing blinks
    var oldBar = cur.querySelector('[data-duo-sticky]'), newBar = next.querySelector('[data-duo-sticky]');
    if (oldBar && newBar && oldBar.classList.contains('is-on')) newBar.classList.add('is-on');
    if (cur.classList.contains('is-still')) next.classList.add('is-still');
    var oldVals = cur.querySelector('.duo-vals'), newVals = next.querySelector('.duo-vals');
    if (oldVals && newVals && oldVals.classList.contains('is-still')) newVals.classList.add('is-still');
    // a photo that is scrolled away stays out of the cross-fade (it would fly in)
    var oldStage = cur.querySelector('.duo-pdp__stage'), newStage = next.querySelector('.duo-pdp__stage');
    if (oldStage && oldStage.getBoundingClientRect().bottom < 0) {
      oldStage.style.viewTransitionName = 'none';
      if (newStage) newStage.style.viewTransitionName = 'none';
    }
    var apply = function () {
      var top0 = oldRoot.getBoundingClientRect().top;
      if (opts.push) { try { history.pushState({ duoHop: 1 }, '', url); } catch (e) { /* the address stays; the drink still changes */ } }
      cur.parentNode.replaceChild(next, cur);
      if (oldName && newRoot.dataset.name) document.title = document.title.replace(oldName, newRoot.dataset.name);
      init();
      var nb = newRoot.duoBuilder;
      if (nb && keep) {
        nb.touchedSteps = keep.touched || {};
        if (keep.mode === 'mix' && !keep.started && nb.setBox && keep.pack > 1) { nb.mode = 'mix'; nb.mixHow = keep.mixHow; nb.pack = keep.pack; }
        if (keep.mixOpen) nb.mixOpen = true;
        if (keep.more && nb.moreGrid && !nb.moreOpen) nb.showMore(true); else nb.render();
      }
      var nkn = newRoot.querySelector('[data-duo-kname]');
      if (okn && nkn && okn.value) {
        nkn.value = okn.value;
        var kopen = nkn.closest('.duo-kname__open'), ktog = newRoot.querySelector('[data-duo-kname-toggle]');
        if (kopen) kopen.hidden = false;
        if (ktog) ktog.hidden = true;
      }
      if (window.duoPdpThumbs) window.duoPdpThumbs();
      // the header's sign-in link comes back to this drink
      var acct = document.querySelector('.duo-top__acct');
      if (acct && /return_to=/.test(acct.getAttribute('href') || '')) acct.setAttribute('href', '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname));
      document.dispatchEvent(new CustomEvent('duo:swapped', { detail: { path: path } }));
      // she stays where she was: the card keeps its place on her screen
      if (inCard) {
        var d = newRoot.getBoundingClientRect().top - top0;
        if (Math.abs(d) > 1) {
          // on desktop Horizon scrolls .page-wrapper, not the window (v3, Oct 28: the words above
          // the card now differ in height from drink to drink, so this has to move the real scroller)
          var sc = scrollerOf(newRoot);
          if (sc) sc.scrollBy({ top: d, behavior: 'instant' }); else window.scrollBy({ top: d, behavior: 'instant' });
        }
      }
      if (hadFocus) {
        var nowDot = newRoot.querySelector('[data-duo-step="1"] .duo-swatches [aria-current]');
        if (nowDot) { try { nowDot.focus({ preventScroll: true }); } catch (e) { /* fine */ } }
      }
    };
    HOP.used = true;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (document.startViewTransition && !calm) {
      HOP.busy = true;
      var free = function () { HOP.busy = false; };
      try {
        var vt = document.startViewTransition(apply);
        vt.finished.then(free, free);
      } catch (e) { free(); apply(); }
    } else apply();
    // the photos beside the new drink
    window.setTimeout(function () { hopNear().forEach(function (pth) { if (getHop(pth)) warmLead(pth); }); }, 400);
    return true;
  }

  /* A flavour dot: the drink changes in place when it can; otherwise the link is
     followed as before. Her key, Plus Ones, name and Little DUO ride in the dot's own
     link either way (paintHops). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-duo-hop]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
    var root = document.querySelector('[data-duo-build]');
    if (root && root.duoBuilder) root.duoBuilder.paintHops();
    if (root && root.duoBuilder && hopCan()) {
      e.preventDefault();
      if (HOP.busy) return;
      var path = hopPath(a);
      if (getHop(path) && hopTo(path, a.getAttribute('href'), { push: true, from: a })) return;
      // not here yet: fetch it now, and give up on a slow line
      HOP.busy = true;
      a.classList.add('is-busy');
      var over = false, plain = function () { if (over) return; over = true; window.location.href = a.getAttribute('href'); };
      var bail = window.setTimeout(plain, 4000);
      fetchHop(path, true).then(function () {
        if (over) return;
        over = true;
        window.clearTimeout(bail);
        HOP.busy = false;
        a.classList.remove('is-busy');
        if (!hopTo(path, a.getAttribute('href'), { push: true, from: a })) window.location.href = a.getAttribute('href');
      }, function () { window.clearTimeout(bail); plain(); });
      return;
    }
    // The plain link, from a dot inside the card on a phone: keep her place. The next
    // page opens with the card where it was on screen, and the photo does not fly in
    // from above the screen when it was scrolled away (phone audit, 2026-09-27). Her
    // place rides in this tab's storage; sections/duo-product.liquid reads it before
    // first paint.
    if (root && a.closest('[data-duo-build]') && window.matchMedia && window.matchMedia('(max-width: 899px)').matches) {
      try { sessionStorage.setItem('duo:at', JSON.stringify({ at: Math.round(root.getBoundingClientRect().top), path: (a.dataset.base || a.getAttribute('href')).split('?')[0], t: Date.now() })); } catch (err) { /* private mode: she lands at the top */ }
      var st = document.querySelector('.duo-pdp__stage');
      if (st && st.getBoundingClientRect().bottom < 0) st.style.viewTransitionName = 'none';
    }
  });
  // a finger or a pointer on a dot: have that drink (and its photo) ready
  ['touchstart', 'pointerover'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var a = e.target.closest && e.target.closest('a[data-duo-hop]');
      if (!a || !hopCan()) return;
      var path = hopPath(a);
      fetchHop(path, true).then(function () { warmLead(path); }, function () { /* the tap falls back to the link */ });
    }, { passive: true });
  });
  // Back and Forward between drinks changed in place
  window.addEventListener('popstate', function () {
    if (!HOP.used) return;
    var cur = pdp(), root = cur && cur.querySelector('[data-duo-build]');
    if (!root) return;
    var path = location.pathname;
    if (root.dataset.handle && path.split('/').pop() === root.dataset.handle) return;
    if (!getHop(path) || !hopTo(path, location.href, { push: false })) window.location.reload();
  });
  hopSoon();

  /* Back from Shopify's sign-in with the Back button: the page comes out of the
     browser's page cache with the button still busy. Put it back. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-duo-build]'), function (r) {
      var bd = r.duoBuilder;
      if (!bd || !bd.busy) return;
      bd.busy = false;
      if (bd.addBtn) bd.addBtn.classList.remove('is-busy');
      var sb = document.querySelector('[data-duo-sticky-btn]');
      if (sb) sb.disabled = false;
      bd.render();
    });
  });

  /* The file loads async (2026-10-01), so the builder no longer waits behind every
     other script on the page (it was live about 0.6 s after the page showed at phone
     speed). Whichever comes last starts it: this file, or the card (the product
     section calls duoBuilderInit after its markup AND its <style> block, and sets
     __duoCard). A card that is still being read, or not styled yet, is never started
     early: the builder measures the Plus One rows when it starts. Once everything has
     loaded the rows are measured once more, in case a style arrived late. */
  window.addEventListener('load', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-duo-build]'), function (r) {
      if (!r.duoBuilder) return;
      Array.prototype.forEach.call(r.querySelectorAll('.duo-p1inline'), function (g) { g.duoRows = ''; });
      r.duoBuilder.fillRows();
    });
  }, { once: true });
  window.duoBuilderInit = init;
  if (document.readyState !== 'loading' || window.__duoCard) init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
